import {useTranslation} from 'react-i18next'

type FundamentalAvailableLanguages = 'en' | 'de'

export const useFundamentalsLanguage = (): FundamentalAvailableLanguages => {
  const {i18n} = useTranslation()
  const language = i18n.language

  if (language.startsWith('de')) {
    return 'de'
  }

  return 'en'
}
